module.exports = __webpack_public_path__ + "static/img/map.f45325b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/map.jpg
// module id = QpmO
// module chunks = 0